import React from 'react';
import { Route } from 'react-router-dom';
import config from '../config';
import path from '../helpers/path';
import * as AdvancedTemplate from './advancedTemplate';
import * as RetailTemplate from './retailTemplate';
import * as LondonTemplate from './londonTemplate';
import * as MilanAltTemplate from './milanAltTemplate';
import * as EotcTemplate from './EotcTemplate';
import * as basicTradingTemplate from './basicTradingTemplate';
import * as v3standardTemplate from './v3standardTemplate';
import { settingsNavItems, settingsRoutesArray } from './settingsRoutes';
export var mainNavOptions = {
  mainNavItems: [],
  settingsPath: ''
};
export var subNavOptions = {
  subNavItems: []
};
export var settingsNav = {
  items: []
};
export var walletsPath = {
  path: ''
};
export var walletDetailPath = {
  path: ''
};
export var defaultPath = {
  path: ''
};
export var routeTemplate = {
  routes: function routes() {
    return React.createElement('div', null, ' Loading ');
  }
};
export var AssignRoutes = function AssignRoutes() {
  switch (config.global.template) {
    case 'MILAN':
    case 'RETAIL':
      AssignRouteValues(RetailTemplate);
      break;
    case 'MILAN-ALT':
      AssignRouteValues(MilanAltTemplate);
      break;
    case 'NEWYORK':
    case 'ADVANCED':
      AssignRouteValues(AdvancedTemplate);
      break;
    case 'CAPETOWN':
    case 'BASICTRADING':
      AssignRouteValues(basicTradingTemplate);
      break;
    case 'LONDON':
      AssignRouteValues(LondonTemplate);
      break;
    case 'GALAXY':
    case 'EOTC':
      AssignRouteValues(EotcTemplate);
      break;
    case 'STANDARD':
      AssignRouteValues(v3standardTemplate);
      break;
    default:
      AssignRouteValues(RetailTemplate);
      break;
  }
};
var AssignRouteValues = function AssignRouteValues(source) {
  mainNavOptions.mainNavItems = source.mainNavOptions.mainNavItems;
  mainNavOptions.settingsPath = source.mainNavOptions.settingsPath;
  subNavOptions.subNavItems = source.subNavItems;
  settingsNav.items = settingsNavItems;
  walletsPath.path = source.walletsPath;
  walletDetailPath.path = source.walletDetailPath;
  defaultPath.path = source.routesArray[0].path;
  routeTemplate.routes = SetupRoutes(source.routesArray);
};
var SetupRoutes = function SetupRoutes(routesArray) {
  return React.createElement(React.Fragment, null, routesArray.concat(settingsRoutesArray).filter(function (i) {
    return i.show === undefined || i.show;
  }).map(function (item) {
    return React.createElement(Route, {
      exact: item.exact,
      path: path(item.path),
      key: item.path,
      render: item.render
    });
  }));
};